<section class="py-7">
  <div class="overflow-x-auto">
    <div
      class="no-scrollbar desk:centered-with-padding flex w-screen shrink-0 gap-x-2.5 gap-y-1.5 overflow-x-auto text-nowrap pl-5 desk:w-auto desk:flex-wrap">
      @let faqListUrl = data.faqListUrl ? [data.faqListUrl] : [];
      @let currentCategory = this.filter() || this.currentCategory();
      @for (category of categories(); track category.name) {
        <a
          [routerLink]="faqListUrl"
          [queryParams]="{ categorie: category.name }"
          [class.bg-anis]="currentCategory === category.name"
          class="rounded-[10px] border-2 px-[14px] py-3">
          {{ category.name }}
        </a>
      }
      <div class="w-2.5 shrink-0"></div>
    </div>
  </div>
</section>
